import Mousetrap from 'mousetrap'
import globalBind from './mousetrap-global-bind'
import bindDictionary from './mousetrap-bind-dictionary'
import pause from './mousetrap-pause'

globalBind(Mousetrap)
bindDictionary(Mousetrap)
pause(Mousetrap)
export default Mousetrap
